import { defineStore } from 'pinia';

export const useNetworkStore = defineStore('network', {
  state: () => ({
    tick: 0
  }),
  actions: {
    /**
     * Decides if the network error tick should increment.
     * If it does, this signal can be used to show a toast.
     *
     * @param error Error caught after attempting a fetch() call.
     */
    signalIssue(error: unknown) {
      if (!error) {
        return;
      }

      if ((error as { message: string }).message.includes('Failed to fetch')) {
        this.tick++;
      }

      if ((error as { message: string }).message.includes('Load failed')) {
        this.tick++;
      }
    }
  }
});
